// Check if admin is authenticated (simple localStorage check)
export const isAdminAuthenticated = () => {
  return !!localStorage.getItem('adminToken');
};

// Get admin token
export const getAdminToken = () => {
  return localStorage.getItem('adminToken');
};

// Clear admin authentication
export const clearAdminAuth = () => {
  localStorage.removeItem('adminToken');
};